export const MAX_IMAGE_KB = 320;
export const MAX_IMAGE_BYTES = MAX_IMAGE_KB * 1024;

/**
 * Client-side compressor — same iterative canvas trick used by the
 * Medical Record dialog. Ensures a background/logo upload stays under
 * ~220KB regardless of the source resolution so the whole template
 * document keeps its Mongo write reasonable.
 */
export async function compressToDataUrl(file, opts = {}) {
  // A5 landscape at 300dpi = 2480×1748 px — bump the ceiling accordingly
  // so backgrounds and logos stay crisp when rendered onto a real A5
  // print sheet rather than the ~475px preview thumbnail.
  const { keepAlpha = false, maxDim = 2400 } = opts;
  const img = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Could not read file"));
    reader.onload = () => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("Could not decode image"));
      image.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
  const longEdge = Math.max(img.naturalWidth, img.naturalHeight);
  let scale = longEdge > maxDim ? maxDim / longEdge : 1.0;
  let quality = 0.85;
  let dataUrl = "";
  for (let i = 0; i < 12; i++) {
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
    const ctx = canvas.getContext("2d");
    if (!keepAlpha) {
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    dataUrl = keepAlpha
      ? canvas.toDataURL("image/png")
      : canvas.toDataURL("image/jpeg", quality);
    const b64 = dataUrl.split(",", 2)[1] || "";
    const bytes = Math.floor((b64.length * 3) / 4);
    if (bytes <= MAX_IMAGE_BYTES) return dataUrl;
    if (!keepAlpha && quality > 0.45) quality -= 0.12;
    else scale *= 0.85;
  }
  return dataUrl;
}
